let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3zgfm")).then(() => parcelRequire('6Zwhu'));